import MoonIcon from 'components/common/icons/MoonIcon'
import { ReactNode } from 'react'

const OnBreakBanner = ({
  children,
  heading,
}: {
  children: ReactNode
  heading: string
}) => {
  return (
    <div className="flex flex-col items-center p-8 bg-white rounded-xl md:rounded-none">
      <div className="text-orange-1 w-8 mb-6">
        <MoonIcon />
      </div>
      <h2 className="text-k/24_120 mb-3 text-center md:text-k/18_120">
        {heading}
      </h2>
      <div className="text-k/18_120 text-grey-10 space-y-6 flex flex-col items-center md:text-k/14_120">
        {children}
      </div>
    </div>
  )
}

export default OnBreakBanner
